<template>
  <div class="p-3 bg-white">
    <div id="EditCallbackNumberFormContainer" class="vs-con-loading__container">
      <shared-messages-callback-numbers-edit
        @editCallbackNumberSuccess="editCallbackNumberSuccess"
      ></shared-messages-callback-numbers-edit>

      <div class="text-center">
        <vs-button id="editCallbackNumberButton" class="m-2" color="primary" type="filled" @click.prevent="updateCallbackNumber">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelEditCallbackNumber">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>

import SharedMessagesCallbackNumbersEdit from '@/views/Shared/Messages/CallbackNumbers/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Messages.CallbackNumber.Edit',
  components: {
    SharedMessagesCallbackNumbersEdit
  },
  mounted () {
    EventBus.$emit('initCallbackNumberGetFormData', {id: this.$route.params.id})
  },
  methods: {
    updateCallbackNumber () {
      EventBus.$emit('initUpdateCallbackNumber')
    },
    editCallbackNumberSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_message_callback_table')
      window.close()
    },
    cancelEditCallbackNumber () {
      this.$windowOpenerHelper.notifyOpener('reload_message_category_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
